import { render, staticRenderFns } from "./DrawerConfigurationControl.vue?vue&type=template&id=00b50dbc"
import script from "./DrawerConfigurationControl.vue?vue&type=script&lang=js"
export * from "./DrawerConfigurationControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports